import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LanguageState {
  locale: string;
  setLocale: (locale: string) => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      locale: 'vi', // Default to Vietnamese
      setLocale: (locale: string) => {
        set({ locale });
        // Store in localStorage for consistency with other apps
        localStorage.setItem('ECommerce_language', locale);
      },
    }),
    {
      name: 'language-storage',
      partialize: (state) => ({ locale: state.locale }),
    }
  )
);

// Initialize from localStorage if available (only in browser)
if (typeof window !== 'undefined') {
  try {
    const storedLanguage = localStorage.getItem('ECommerce_language');
    if (storedLanguage && ['en', 'vi'].includes(storedLanguage)) {
      useLanguageStore.getState().setLocale(storedLanguage);
    } else {
      // If French or other unsupported language is stored, reset to Vietnamese
      if (storedLanguage === 'fr') {
        useLanguageStore.getState().setLocale('vi');
      } else {
        // Ensure default locale is set to Vietnamese
        useLanguageStore.getState().setLocale('vi');
      }
    }
  } catch (error) {
    console.warn('Failed to initialize language from localStorage:', error);
    // Ensure default locale is set to Vietnamese even if localStorage fails
    useLanguageStore.getState().setLocale('vi');
  }
}

